<template>
    <div>
        <v-card>
            <s-toolbar label="Reporte de Entrega" dark color="#8e8f91" excel @excel="downloadExcel()">
                <div style="display: flex; justify-content: space-between">
                    <div style="display: flex;">
                        <div>
                            <v-text-field id="tour-search" style="margin-top:-1px; width:150px !important;" ref="buscar" height="30"
                                width="60" v-model="textSearch" dense clearable hide-details @keyup.enter="clickSearch()"/>
                        </div>
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="'white'" text v-on="on" small @click="clickSearch()"> <v-icon> mdi-magnify</v-icon></v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="white" text v-on="on" v-bind="attrs" small class="ml-1" @click="openTrackingConfigDialog()">
                                    <v-icon small>mdi-cog</v-icon>
                                </v-btn>
                            </template>
                            <span>Configurar columnas a extraer del Excel de Tracking</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="$fun && typeof $fun.isAdmin === 'function' && $fun.isAdmin()">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="white"
                                    text
                                    v-on="on"
                                    v-bind="attrs"
                                    small
                                    class="ml-1"
                                    :loading="testingConnection"
                                    @click="testTrackingConnection()"
                                >
                                    <v-icon small color="white">mdi-lan-connect</v-icon>
                                </v-btn>
                            </template>
                            <span>Probar acceso y lectura del archivo Excel en la red</span>
                        </v-tooltip>
                    </div>
                </div>
            </s-toolbar>

            <v-container>
                <v-alert v-if="showCustomerWarning" type="warning" dense dismissible @input="showCustomerWarning = false" class="mb-4">
                    Debe seleccionar un cliente obligatoriamente antes de consultar los datos.
                </v-alert>

                <v-row justify="center" align="center">
                    <v-col cols="12" md="3">
                        <sselect-client-sap
                            label="Cliente *"
                            v-model="filter.CustomerID"
                            :error="showCustomerWarning && !filter.CustomerID"
                        ></sselect-client-sap>
                    </v-col>
                    <v-col cols="12" md="2">
                        <s-select-definition 
                            :def="1173" 
                            label="Tipo de Cultivo"
                            v-model="filter.TypeCultive"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <s-select-campaign
                            label="Campaña"
                            v-model="filter.CmpID"
                        />
                    </v-col>
                    <v-col cols="12" md="4" v-if="activeTab !== 0" class="d-flex align-center">
                        <s-select
                            v-model="jumpWeekSelect"
                            :items="weekItems"
                            item-text="text"
                            item-value="value"
                            label="Ir a Departure WK"
                            @change="jumpToWeek"
                        />
                        <v-btn
                            small
                            color="primary"
                            class="ml-3 rounded-pill text-none px-3 font-weight-medium white--text elevation-2"
                            @click="jumpToCurrentWeek"
                            title="Ir a la semana actual"
                        >
                            <v-icon small left>mdi-calendar-check</v-icon>
                            Departure WK Actual ({{ currentWeek }})
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Modern Minimalist Tabs (Resumen + Semanas 1..52) -->
                <v-tabs
                    v-model="activeTab"
                    background-color="transparent"
                    color="primary"
                    show-arrows
                    center-active
                    class="mt-2 mb-4"
                    @change="onTabChange"
                >
                    <v-tab :value="0" :key="0" class="font-weight-bold">
                        <v-icon left small>mdi-table</v-icon>
                        SHIPMENTS
                    </v-tab>
                    <v-tab v-for="wk in 52" :value="wk" :key="wk" class="text-none">
                        <template v-if="wk === currentWeek">
                            <v-chip
                                small
                                color="primary"
                                class="font-weight-bold text-caption white--text shadow-sm"
                                style="height: 24px;"
                            >
                                <v-icon left x-small color="amber lighten-3">mdi-star</v-icon>
                                Departure WK {{ wk }} • Actual
                            </v-chip>
                        </template>
                        <template v-else>
                            Departure WK {{ wk }}
                        </template>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <!-- Tab 0: Resumen General -->
                    <v-tab-item :value="0" :key="0">
                        <v-data-table
                            id="tour-table"
                            item-key="Line"
                            dense
                            fixed-header
                            :items="items"
                            :headers="headers"
                            :items-per-page="20"
                            v-model="selected"
                            :loading="loading"
                        >
                            <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
                                <span :class="{ 'excel-highlight-chip': isExcelHighlighted(item, header.value) }">
                                    {{ item[header.value] }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Tabs 1..52: Semanas -->
                    <v-tab-item v-for="wk in 52" :value="wk" :key="wk">
                        <v-card flat class="rounded-xl pa-5 grey lighten-5">
                            <div class="d-flex align-center justify-space-between flex-wrap gap-2 mb-4">
                                <div class="d-flex align-center">
                                    <v-avatar color="primary lighten-5" size="48" class="mr-3 elevation-1">
                                        <v-icon color="primary">mdi-calendar-month-outline</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="d-flex align-center">
                                            <h3 class="text-h6 font-weight-bold mb-0 mr-2 text--primary">Departure WK {{ wk }}</h3>
                                            <v-chip
                                                v-if="wk === currentWeek"
                                                small
                                                color="success"
                                                class="font-weight-bold white--text elevation-1"
                                            >
                                                <v-icon x-small left>mdi-check-circle</v-icon>
                                                Semana Actual
                                            </v-chip>
                                        </div>
                                        <span class="caption grey--text text--darken-1">Reporte de entregas por contenedor (<code>RP_REPORT_DISPATCH_CLIENT</code>)</span>
                                    </div>
                                </div>

                                <div class="d-flex align-center">
                                    <v-btn
                                        color="primary"
                                        dark
                                        class="rounded-lg text-none px-4 elevation-2 font-weight-bold"
                                        @click="loadWeek()"
                                        :loading="loading"
                                    >
                                        <v-icon left small>mdi-refresh</v-icon> Consultar Departure WK {{ wk }}
                                    </v-btn>
                                </div>
                            </div>

                            <v-divider class="my-4"></v-divider>

                            <v-progress-linear v-if="loading" indeterminate color="primary" class="my-4"></v-progress-linear>

                            <template v-else>
                                <div v-if="containerReportData.containers && containerReportData.containers.length > 0" class="mt-2">
                                    <delivery-container-report :report-data="containerReportData" />
                                </div>

                                <v-sheet v-else color="blue lighten-5" class="pa-5 rounded-lg text-center">
                                    <v-icon color="primary" large class="mb-2">mdi-package-variant-closed-remove</v-icon>
                                    <div class="subtitle-1 font-weight-medium blue--text text--darken-4">
                                        No se encontraron contenedores ni entregas registradas para la <strong>Departure WK {{ wk }}</strong>.
                                    </div>
                                    <div class="caption grey--text text--darken-1">
                                        Seleccione un cliente y haga clic en "Consultar Departure WK {{ wk }}" para cargar la información por contenedor.
                                    </div>
                                </v-sheet>
                            </template>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </v-card>

        <!-- Diálogo Configuración de Campos Excel (Tracking y Exportaciones) -->
        <v-dialog v-model="trackingConfigDialog" max-width="680px" persistent>
            <v-card class="rounded-xl border-light overflow-hidden bg-white elevation-3">
                <v-card-title class="d-flex align-center justify-space-between py-3 px-4 border-light-bottom">
                    <div class="d-flex align-center">
                        <v-icon color="black" class="mr-2">mdi mdi-microsoft-excel</v-icon>
                        <span class="text-subtitle-1 font-weight-bold black--text">
                            Configuración de Columnas de Archivos Excel
                        </span>
                    </div>
                    <v-btn icon small class="black--text" @click="trackingConfigDialog = false" :disabled="savingTrackingConfig">
                        <v-icon small color="black">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4 px-4 pb-2">
                    <div class="pa-3 mb-4 rounded-lg grey lighten-5 border-light d-flex align-start">
                        <v-icon color="black" small class="mr-2 mt-1">mdi-information-outline</v-icon>
                        <div class="text-caption black--text" style="line-height: 1.45;">
                            Especifique los nombres exactos de las columnas a extraer para complementar el reporte. 
                            Puede separar múltiples nombres por comas. Deje el campo vacío si no desea extraer columnas de dicho archivo.
                        </div>
                    </div>

                    <!-- Sección 1: Excel de Tracking Frescos -->
                    <div class="mb-4">
                        <div class="d-flex align-center mb-1">
                            <v-icon small color="black" class="mr-1">mdi-truck-fast-outline</v-icon>
                            <span class="text-subtitle-2 font-weight-bold black--text">
                                1. Excel de Tracking (Post-Embarque - Frescos)
                            </span>
                        </div>
                        <div class="text-caption black--text mb-2">
                            Columnas a extraer de las hojas semanales del archivo de Post-Embarque.
                        </div>
                        <s-text
                            v-model="trackingFieldsValue"
                            label="Columnas de Tracking (separadas por comas)"
                            placeholder="Ej: RTA, TT (REAL), OBS, STATUS"
                            clearable
                        />
                        <div class="text-caption black--text pl-1 mt-1">
                            <span class="font-weight-medium">Ejemplo recomendado:</span> <code class="black--text font-weight-bold">RTA, TT (REAL), OBS, STATUS</code>
                        </div>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <!-- Sección 2: Excel de Exportaciones Nave USA / Nave EUR -->
                    <div class="mb-2">
                        <div class="d-flex align-center mb-1">
                            <v-icon small color="black" class="mr-1">mdi-ferry</v-icon>
                            <span class="text-subtitle-2 font-weight-bold black--text">
                                2. Excel de Exportaciones (Nave USA / Nave EUR)
                            </span>
                        </div>
                        <div class="text-caption black--text mb-2">
                            Columnas a extraer de las hojas Ex_Fresh_USA y Ex_Fresh_EUR de los archivos de Naves.
                        </div>
                        <s-text
                            v-model="exportFieldsValue"
                            label="Columnas de Exportación (separadas por comas)"
                            placeholder="Ej: FREIGHT"
                            clearable
                        />
                        <div class="text-caption black--text pl-1 mt-1">
                            <span class="font-weight-medium">Ejemplo recomendado:</span> <code class="black--text font-weight-bold">FREIGHT</code>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="px-4 py-3 border-light-top">
                    <v-btn
                        outlined
                        class="rounded-lg mr-2 black--text font-weight-medium"
                        style="border-color: #333333;"
                        v-if="$fun && typeof $fun.isAdmin === 'function' && $fun.isAdmin()"
                        :loading="testingConnection"
                        @click="testTrackingConnection()"
                    >
                        <v-icon left small color="black">mdi-lan-connect</v-icon>
                        Probar Acceso Archivos Excel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        class="rounded-lg black--text font-weight-medium"
                        @click="trackingConfigDialog = false"
                        :disabled="savingTrackingConfig"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="rounded-lg px-4 font-weight-medium white--text"
                        @click="saveTrackingConfig"
                        :loading="savingTrackingConfig"
                    >
                        <v-icon left small>mdi-content-save-outline</v-icon>
                        Guardar Cambios
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo selector de hojas Excel -->
        <excel-sheets-dialog
            v-model="showExcelDialog"
            :current-week="currentWeek"
            :available-weeks="activeWeeks"
            @confirm="onExcelSheetsConfirmed"
        />
    </div>
</template>
  
<script>
    import _sReportCustomerService from '@/services/ExternalTrade/ExtReportCustomer.js';
    import _sParameter from "@/services/General/ParameterService";
    import SselectClientSap from '@/components/Sale/SselectClientSap.vue';
    import DeliveryContainerReport from './DeliveryContainerReport.vue';
    import ExcelSheetsDialog from './ExcelSheetsDialog.vue';

	export default {
        components: {
            SselectClientSap,
            DeliveryContainerReport,
            ExcelSheetsDialog
        },
        data() {
            return {
                filter:{
                    CmpID: 0,
                    TypeCultive: 0,
                    CustomerID: null,
                    DepartureNumber: null,
                },
                items: [],
                headers: [],
                loading: false,
                selected: [],
                textSearch: '',
                activeTab: 0,
                currentWeek: 1,
                jumpWeekSelect: null,
                showCustomerWarning: false,
                showExcelDialog: false,
                trackingConfigDialog: false,
                trackingFieldsValue: '',
                trackingParamObj: null,
                exportFieldsValue: '',
                exportParamObj: null,
                savingTrackingConfig: false,
                testingConnection: false,
                containerReportData: {
                    LogisticsSummary: [],
                    containers: [],
                    detail: [],
                    totalByContainer: [],
                    grandTotal: 0
                }
            }
        },
        computed: {
            weekItems() {
                const items = [];
                for (let i = 1; i <= 52; i++) {
                    items.push({
                        text: `Departure WK ${i}${i === this.currentWeek ? ' (Actual)' : ''}`,
                        value: i
                    });
                }
                return items;
            },
            activeWeeks() {
                const weeksSet = new Set();
                if (Array.isArray(this.items) && this.items.length > 0) {
                    this.items.forEach(item => {
                        if (item.WeekRTA) weeksSet.add(Number(item.WeekRTA));
                        if (item.WeekETA) weeksSet.add(Number(item.WeekETA));
                        if (item.DepartureNumber) weeksSet.add(Number(item.DepartureNumber));

                        ['ETA', 'RTA', 'ETD', 'RTD'].forEach(prop => {
                            if (item[prop]) {
                                const wk = this.getISOWeekFromDateStr(item[prop]);
                                if (wk >= 1 && wk <= 52) weeksSet.add(wk);
                            }
                        });
                    });
                }
                return Array.from(weeksSet).sort((a, b) => a - b);
            }
        },
        created() {
            this.currentWeek = this.getCurrentISOWeek();
            this.filter.DepartureNumber = this.currentWeek;
            this.jumpWeekSelect = this.currentWeek;
        },
        methods:{
            getCurrentISOWeek() {
                const date = new Date();
                const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                const dayNum = d.getUTCDay() || 7;
                d.setUTCDate(d.getUTCDate() + 4 - dayNum);
                const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
                return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
            },
            getISOWeekFromDateStr(dateStr) {
                if (!dateStr) return 0;
                const str = String(dateStr).trim();
                const parts = str.split(/[\/\-\s]/);
                let year = 0, month = 0, day = 0;
                if (parts.length >= 3) {
                    if (parts[0].length === 4) {
                        year = parseInt(parts[0]);
                        month = parseInt(parts[1]) - 1;
                        day = parseInt(parts[2]);
                    } else {
                        day = parseInt(parts[0]);
                        month = parseInt(parts[1]) - 1;
                        year = parseInt(parts[2]);
                    }
                    if (year > 2000 && month >= 0 && month < 12 && day > 0 && day <= 31) {
                        const d = new Date(Date.UTC(year, month, day));
                        const dayNum = d.getUTCDay() || 7;
                        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
                        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
                        return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
                    }
                }
                return 0;
            },
            openTrackingConfigDialog() {
                this.savingTrackingConfig = false;
                Promise.all([
                    _sParameter.search({ PrmName: "ComexExcelTrackingFields" }, this.$fun.getUserID()),
                    _sParameter.search({ PrmName: "ComexExcelExportFields" }, this.$fun.getUserID())
                ])
                .then(([resTracking, resExport]) => {
                    if (resTracking && resTracking.data) {
                        this.trackingParamObj = resTracking.data;
                        this.trackingFieldsValue = resTracking.data.PrmValue || '';
                    } else {
                        this.trackingParamObj = null;
                        this.trackingFieldsValue = 'RTA,TT (REAL)';
                    }

                    if (resExport && resExport.data) {
                        this.exportParamObj = resExport.data;
                        this.exportFieldsValue = resExport.data.PrmValue || '';
                    } else {
                        this.exportParamObj = null;
                        this.exportFieldsValue = 'FREIGHT';
                    }

                    this.trackingConfigDialog = true;
                })
                .catch(err => {
                    console.error("Error al buscar parámetros de Excel:", err);
                    if (!this.trackingFieldsValue) this.trackingFieldsValue = 'RTA,TT (REAL)';
                    if (!this.exportFieldsValue) this.exportFieldsValue = 'FREIGHT';
                    this.trackingConfigDialog = true;
                });
            },
            testTrackingConnection() {
                this.testingConnection = true;
                _sReportCustomerService.testConnection(this.filter, this.$fun.getUserID())
                    .then(r => {
                        const res = r.data || {};
                        if (res.files && Array.isArray(res.files)) {
                            let details = [];
                            res.files.forEach(f => {
                                const icon = f.success ? '✅' : '❌';
                                let text = `${icon} [${f.tag}]\n   • Estado: ${f.message}\n   • Ruta: ${f.filePath || 'No configurada'}`;
                                if (f.success) {
                                    text += `\n   • Tamaño: ${f.fileSizeMb} MB (${f.fileSizeBytes} B) | Hojas: ${f.sheetCount} (1ra: '${f.firstSheetName}')`;
                                }
                                details.push(text);
                            });
                            const title = res.success ? "¡PRUEBA DE ACCESO A EXCEL EXITOSA!" : "ATENCIÓN: ERRORES AL ACCEDER A LOS ARCHIVOS EXCEL";
                            const fullMsg = `${title}\n\n${details.join('\n\n')}`;
                            if (this.$fun && typeof this.$fun.alert === 'function') {
                                this.$fun.alert(fullMsg, res.success ? "success" : "warning");
                            } else {
                                alert(fullMsg);
                            }
                        } else if (res.success) {
                            const msg = `${res.message}\n\n• Ruta: ${res.filePath}\n• Tamaño: ${res.fileSizeMb} MB (${res.fileSizeBytes} bytes)\n• Total Hojas: ${res.sheetCount} (Primera hoja: '${res.firstSheetName}')`;
                            if (this.$fun && typeof this.$fun.alert === 'function') {
                                this.$fun.alert(msg, "success");
                            } else {
                                alert(msg);
                            }
                        } else {
                            const msg = `${res.message}\n\n• Ruta probada: ${res.filePath || 'No definida'}`;
                            if (this.$fun && typeof this.$fun.alert === 'function') {
                                this.$fun.alert(msg, "error");
                            } else {
                                alert(msg);
                            }
                        }
                    })
                    .catch(err => {
                        console.error("Error al probar conexión:", err);
                        const errStr = (err && err.response && err.response.data) ? err.response.data : err.message;
                        if (this.$fun && typeof this.$fun.alert === 'function') {
                            this.$fun.alert("Error en el servidor al probar la conexión: " + errStr, "error");
                        }
                    })
                    .finally(() => {
                        this.testingConnection = false;
                    });
            },
            saveTrackingConfig() {
                this.savingTrackingConfig = true;

                const trackingObj = this.trackingParamObj ? {
                    ...this.trackingParamObj,
                    PrmValue: (this.trackingFieldsValue || '').trim()
                } : {
                    PrmID: 0,
                    PrmName: "ComexExcelTrackingFields",
                    PrmDescription: "Campos a extraer del archivo Excel de Tracking Frescos",
                    PrmValue: (this.trackingFieldsValue || '').trim(),
                    SecStatus: 1
                };

                const exportObj = this.exportParamObj ? {
                    ...this.exportParamObj,
                    PrmValue: (this.exportFieldsValue || '').trim()
                } : {
                    PrmID: 0,
                    PrmName: "ComexExcelExportFields",
                    PrmDescription: "Campos a extraer de archivos Excel de Nave USA y EUR",
                    PrmValue: (this.exportFieldsValue || '').trim(),
                    SecStatus: 1
                };

                Promise.all([
                    _sParameter.save(trackingObj, this.$fun.getUserID()),
                    _sParameter.save(exportObj, this.$fun.getUserID())
                ])
                .then(() => {
                    if (this.$fun && typeof this.$fun.toastSuccess === 'function') {
                        this.$fun.toastSuccess("Configuración de columnas guardada correctamente.");
                    } else if (this.$fun && typeof this.$fun.alert === 'function') {
                        this.$fun.alert("Configuración de columnas guardada correctamente.", "success");
                    }
                    this.trackingConfigDialog = false;
                    if (this.filter.CustomerID) {
                        if (this.activeTab === 0) {
                            this.load();
                        } else {
                            this.loadWeek();
                        }
                    }
                })
                .catch(err => {
                    console.error("Error al guardar configuración de campos de Excel:", err);
                    if (this.$fun && typeof this.$fun.alert === 'function') {
                        this.$fun.alert("Error al guardar la configuración de columnas de Excel.", "error");
                    }
                })
                .finally(() => {
                    this.savingTrackingConfig = false;
                });
            },
            validateCustomer() {
                if (!this.filter.CustomerID) {
                    this.showCustomerWarning = true;
                    if (this.$fun && typeof this.$fun.showWarning === 'function') {
                        this.$fun.showWarning('Debe seleccionar un cliente obligatoriamente.');
                    }
                    return false;
                }
                this.showCustomerWarning = false;
                return true;
            },
            load() {
                if (!this.validateCustomer()) return;

                this.loading = true;

                _sReportCustomerService.list(this.filter, this.$fun.getUserID())
                    .then(r => {
                        console.log("r.data list (pivot):", r.data);
                        const data = r.data || {};

                        if (Array.isArray(data) && data.length > 0) {
                            this.headers = Object.keys(data[0])
                                .filter(key => !key.toLowerCase().includes('fromexcel'))
                                .map(key => ({
                                    text: key.replace(/_/g, ' ').toUpperCase(),
                                    value: key
                                }));

                            console.log("this.headers", this.headers);
                        } else {
                            this.headers = [];
                        }
                        
                        this.items = data;
                    })
                    .catch(error => {
                        console.error("Error al cargar datos pivot:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            isExcelHighlighted(item, key) {
                if (!item || !key) return false;
                const val = item[key];
                if (val === null || val === undefined || String(val).trim() === '') {
                    return false;
                }
                if (key === 'ETA') return !!(item.IsEtaFromExcel || item.isEtaFromExcel);
                if (key === 'RTA') return !!(item.IsRtaFromExcel || item.isRtaFromExcel);

                const compactKey = key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
                for (const prop of Object.keys(item)) {
                    if (prop.toLowerCase().includes('fromexcel')) {
                        const compactProp = prop.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
                        if (compactProp.includes(compactKey)) {
                            return !!item[prop];
                        }
                    }
                }
                return false;
            },
            loadWeek() {
                if (!this.validateCustomer()) return;

                this.loading = true;

                _sReportCustomerService.listWeek(this.filter, this.$fun.getUserID())
                    .then(r => {
                        console.log("=========================================");
                        console.log(`RP_REPORT_DISPATCH_CLIENT Data Departure WK ${this.filter.DepartureNumber}:`, r.data);
                        const d = r.data || {};
                        const rawContainers = d.Containers || d.containers || d.LogisticsSummary || d.logisticsSummary || [];
                        console.log(`[DEBUG] Raw containers (${rawContainers.length}):`, rawContainers.map(c => ({ OV: c.OV, AreaProd: c.AreaProd, FreightText: c.FreightText, Freight: c.Freight })));
                        console.log("=========================================");

                        this.containerReportData = {
                            containers: rawContainers.map(c => ({
                                departureWeek: c.DepartureWeek || c.departureWeek || c.Departureweek,
                                arrivalWeek: c.ArrivalWeek || c.arrivalWeek || c.Arrivalweek,
                                shippingLine: c.ShippingLine || c.shippingLine || c.Shippingline,
                                vessel: c.Vessel || c.vessel,
                                container: c.Container || c.container,
                                etd: c.ETD || c.etd || c.Etd,
                                eta: c.ETA || c.eta || c.Eta,
                                rta: c.RTA || c.rta || c.Rta,
                                isEtaFromExcel: c.IsEtaFromExcel !== undefined ? c.IsEtaFromExcel : (c.isEtaFromExcel !== undefined ? c.isEtaFromExcel : false),
                                isRtaFromExcel: c.IsRtaFromExcel !== undefined ? c.IsRtaFromExcel : (c.isRtaFromExcel !== undefined ? c.isRtaFromExcel : false),
                                dayRTA: c.DayRTA || c.dayRTA || c.DayRta || '',
                                freightText: c.FreightText || c.freightText || (c.Freight !== null && c.Freight !== undefined ? String(c.Freight) : '') || '',
                                pl: c.PL || c.pl || c.Pl
                            })),
                            detail: (d.Detail || d.detail || []).map(i => ({
                                sizes: i.Sizes || i.sizes,
                                fpb: i.FPB !== undefined && i.FPB !== null ? i.FPB : (i.fpb !== undefined && i.fpb !== null ? i.fpb : null),
                                location: i.Location || i.location,
                                typeOfCrop: i.TypeOfCrop || i.typeOfCrop,
                                variety: i.Variety || i.variety,
                                kg: i.Kg !== undefined && i.Kg !== null ? i.Kg : (i.kg !== undefined && i.kg !== null ? i.kg : null),
                                container: i.Container || i.container,
                                pl: i.PL || i.pl || i.Pl
                            })),
                            totalByContainer: (d.TotalByContainer || d.totalByContainer || []).map(t => ({
                                container: t.Container || t.container,
                                total: t.Total || t.total
                            })),
                            grandTotal: d.GrandTotal || d.grandTotal || 0
                        };
                    })
                    .catch(error => {
                        console.error("Error al cargar datos por semana:", error);
                        this.containerReportData = {
                            LogisticsSummary:[],
                            containers: [],
                            detail: [],
                            totalByContainer: [],
                            grandTotal: 0
                        };
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            onTabChange(tabIndex) {
                if (tabIndex === 0) {
                    if (this.filter.CustomerID) {
                        this.load();
                    }
                } else {
                    const weekNum = Number(tabIndex);
                    this.filter.DepartureNumber = weekNum;
                    this.jumpWeekSelect = weekNum;
                    if (this.filter.CustomerID) {
                        this.loadWeek();
                    }
                }
            },
            jumpToWeek(val) {
                const weekNum = (typeof val === 'number') ? val : (val && val.value ? val.value : Number(val));
                if (!isNaN(weekNum) && weekNum >= 1 && weekNum <= 52) {
                    this.activeTab = weekNum;
                    this.filter.DepartureNumber = weekNum;
                    this.jumpWeekSelect = weekNum;
                    if (this.filter.CustomerID) {
                        this.loadWeek();
                    }
                }
            },
            jumpToCurrentWeek() {
                this.jumpToWeek(this.currentWeek);
            },
            clickSearch() {
                console.log("this.filter", this.filter);
                if (this.activeTab === 0) {
                    this.load();
                } else {
                    this.filter.DepartureNumber = this.activeTab;
                    this.loadWeek();
                }
            },
            downloadExcel() {
                if (!this.validateCustomer()) return;
                // Abrir el diálogo de selección de hojas en lugar de descargar directamente
                this.showExcelDialog = true;
            },
            onExcelSheetsConfirmed(selectedSheets) {
                this.showExcelDialog = false;
                if (!selectedSheets || selectedSheets.length === 0) return;

                this.loading = true;

                const filterWithSheets = {
                    ...this.filter,
                    SelectedSheets: selectedSheets
                };

                _sReportCustomerService.excel(filterWithSheets, this.$fun.getUserID())
                    .then(r => {
                        const fileName = `Reporte_Despachos_${this.filter.CustomerID || 'Cliente'}`;
                        this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, fileName);
                    })
                    .catch(error => {
                        console.error("Error al descargar Excel:", error);
                        if (this.$fun && typeof this.$fun.showError === 'function') {
                            this.$fun.showError('Ocurrió un error al generar el archivo Excel.');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    }
</script>

<style scoped>
.excel-highlight-chip {
    background-color: #e8f5e9;
    color: #2e7d32;
    padding: 3px 8px;
    border-radius: 4px;
    font-weight: bold;
    border: 1px solid #a5d6a7;
    display: inline-block;
}
.border-light {
    border: 1px solid #e2e8f0 !important;
}
.border-light-bottom {
    border-bottom: 1px solid #e2e8f0 !important;
}
.border-light-top {
    border-top: 1px solid #e2e8f0 !important;
}
</style>

